<main>
    <footer>
        <br />
        <p>
            <i
                >Astroneer content and materials are the intellectual property
                of their respective owners</i
            >
        </p>
    </footer>
</main>

<style>
    footer {
        font-size: x-small;
        text-align: center;
    }
</style>
